import { render } from "./FloatCreate.vue?vue&type=template&id=62ab1da2"
import script from "./FloatCreate.vue?vue&type=script&lang=js"
export * from "./FloatCreate.vue?vue&type=script&lang=js"

import "./FloatCreate.vue?vue&type=style&index=0&id=62ab1da2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__